// import { initializeConnect } from "react-redux/es/components/connect";

const getDataFieldline = () => {
  return [
    {
      title: "X Axis",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "groupByFields",
      itemInArray: true,
    },
    {
      title: "Metrics",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "valueColumns",
      itemInArray: true,
    },
    {
      title: "Dimension",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "rows",
      itemInArray: true,
    },
    {
      title: "Filters",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "filters",
      itemInArray: true,
    },
    {
      title: "Tooltip",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "tooltip",
      itemInArray: true,
    },
    {
      title: "Row Limit",
      type: "dropdown",
      reduxKey: "rowLimit",
      itemInArray: false,
      defaultValue: 500,
      valueType: "Number",
      canEdit: true,
    },
  ];
};

const getCustomizationFieldline = () => {
  return [
    {
      title: "Point Size",
      type: "range",
      defaultValue: 6,
      minValue: 5,
      maxValue: 20,
      reduxKey: "pointSize",
      itemInArray: false,
    },

    //color type select
    {
      title: "Color",
      type: "COLOR",
      reduxKey: "colorSchemeid",
      defaultType: "RANDOM",
    },
    {
      title: "LineType",
      type: "SELECT_BOX",
      reduxKey: "lineTypes",
      options: [
        { label: "Linear", value: "linear" },
        { label: "Monotone", value: "monotone" },
        { label: "Step", value: "step" },
        { label: "linearClosed", value: "linearClosed" },
      ],
      defaultValue: { label: "linear", value: "linear" },
      isParent: true,
    },

    {
      title: "Label",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: false,
      reduxKey: "isLabelVisible",
      innerComponents: [
        {
          title: "Font Color",
          type: "fontColor",
          reduxKey: "labelFontColor",
          parentType: "CONTAINER_WITH_TOGGLE",
        },
        {
          title: "Position",
          type: "SELECT_BOX",
          reduxKey: "labelPosition",
          options: [
            // { label: "Right", value: "right" },
            { label: "Top", value: "top" },
            { label: "Bottom", value: "bottom" },
            { label: "Center", value: "center" },

            // { label: "Bottom", value: "bottom" },
          ],
          defaultValue: { label: "Top", value: "top" },
          isParent: true,
        },

        {
          title: "Font Size",
          type: "range",
          defaultValue: 13,
          minValue: 10,
          maxValue: 40,
          reduxKey: "labelFontSize",
          isParent: true,
          parentType: "CONTAINER_WITH_TOGGLE",
        },
        {
          title: "Rotate",
          type: "range",
          defaultValue: 0,
          minValue: 0,
          maxValue: 360,
          reduxKey: "labelRotate",
          isParent: true,
          parentType: "CONTAINER_WITH_TOGGLE",
        },
      ],
    },

    {
      title: "Grid",
      type: "checkbox",
      defaultValue: false,
      reduxKey: "isGridVisible",
    },
    {
      title: "TransPose",
      type: "checkbox",
      defaultValue: false,
      reduxKey: "isTransposeVisible",
    },
    //legend
    {
      title: "Legend",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: true,
      reduxKey: "isLegendVisible",
      innerComponents: [
        {
          title: "Align",
          type: "SELECT_BOX",
          reduxKey: "legendAlign",
          options: [
            { label: "Left", value: "left" },
            { label: "Center", value: "center" },
            { label: "Right", value: "right" },
          ],
          defaultValue: { label: "Center", value: "center" },
          isParent: true,
        },
        {
          title: "Vertical Align",
          type: "SELECT_BOX",
          reduxKey: "legendVerticalAlign",
          options: [
            { label: "Top", value: "top" },

            { label: "Bottom", value: "bottom" },
          ],
          defaultValue: { label: "Bottom", value: "top" },
          isParent: true,
        },
        {
          title: "Layout",
          type: "SELECT_BOX",
          reduxKey: "legendLayout",
          options: [
            { label: "Horizontal", value: "horizontal" },
            { label: "Vertical", value: "vertical" },
          ],
          defaultValue: { label: "Horizontal", value: "horizontal" },
          isParent: true,
        },
      ],
    },
  ];
};

export { getDataFieldline, getCustomizationFieldline };
